module.exports = __webpack_public_path__ + "img/banner.76e688e4.jpg";